//@ts-nocheck
import React from 'react'

import { ToolbarWrapper } from './ToolbarWrapper'
import { HoveringToolbar } from './HoveringToolbar'
import BaseToolbar from './Toolbar'

export declare interface MainToolbarProps {
  ref: React.MutableRefObject;
  contentStack: boolean
  customToolbarComponents: any
  toolbarMode: any
  // templateregistrycondition: any,
  className: any
  fieldName: string
  editorRef: any
  pluginslen: any
  FullScreenToggle?: React.ReactNode
}

const MainToolbar = React.memo(
  React.forwardRef((props: Partial<MainToolbarProps>, ref: any) => {
    const { contentStack, customToolbarComponents, toolbarMode = 'advance', fieldName, editorRef, pluginslen, FullScreenToggle } = props
    return (
      <ToolbarWrapper ref={ref} {...props}>
        <BaseToolbar
          toolbarType={'mainToolbar'}
          contentStack={contentStack}
          toolbarMode={toolbarMode}
          customToolbarComponents={customToolbarComponents}
          fieldName={fieldName}
          editorRef={editorRef}
          pluginslen={pluginslen}
          FullScreenToggle={FullScreenToggle}
        />
      </ToolbarWrapper>
    )
  },
    (prev, next) => {
      return prev.pluginslen === next.pluginslen && prev.FullScreenToggle === next.FullScreenToggle
    }
  ))

export {
  MainToolbar,
  HoveringToolbar
};
